import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export type MapProvider = 'osm' | 'google';

export interface LeafletTilesConfig {
  url: string;
  options: {
    attribution: string;
    maxZoom?: number;
  };
}

@Injectable({
  providedIn: 'root',
})
export class MapProviderAdapterService {
  get provider(): MapProvider {
    const configured = `${(environment as any)?.map?.provider || 'osm'}`.toLowerCase();
    return configured === 'google' ? 'google' : 'osm';
  }

  getTilesConfig(): LeafletTilesConfig {
    if (this.provider === 'google') {
      const key = (environment as any)?.map?.googleApiKey || '';
      // Placeholder for a future Google provider implementation.
      return {
        url: `https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&key=${key}`,
        options: {
          attribution: 'Google Maps',
          maxZoom: 20,
        },
      };
    }

    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      options: {
        attribution: '&copy; OpenStreetMap contributors',
        maxZoom: 19,
      },
    };
  }
}

